export class ConfigurationManager {
    static getValueIfExists(configuration, key) {
        if (!configuration)
            return undefined;
        let value = configuration;
        let keys = key.split('.');
        for (let element of keys) {
            if (value[element]) {
                value = value[element];
            }
            else {
                return undefined;
            }
        }
        return value;
    }
    static setValueIfExists(configuration, key, propertyToSet) {
        if (!configuration)
            return propertyToSet;
        let value = configuration;
        let keys = key.split('.');
        for (let element of keys) {
            if (value[element]) {
                value = value[element];
            }
            else {
                return propertyToSet;
            }
        }
        return value;
    }
}
